/**
 * Visitor Tracking Client
 * Tracks page views and sends data to AWS Lambda backend
 */

const TRACKING_API_ENDPOINT = 'https://api.limkc.com/visitor/track';

class VisitorTracker {
  constructor() {
    this.sessionStart = Date.now();
    this.lastPage = null;
  }

  /**
   * Track page view
   */
  async trackPageView(page = window.location.pathname) {
    try {
      // Don't track if same page (avoid duplicate on re-renders)
      if (page === this.lastPage) {
        return;
      }

      this.lastPage = page;

      const sessionDuration = Math.floor((Date.now() - this.sessionStart) / 1000);

      const data = {
        page,
        referrer: document.referrer || 'direct',
        sessionDuration,
        timestamp: new Date().toISOString()
      };

      // Send tracking request (non-blocking)
      await fetch(TRACKING_API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        // Use keepalive to ensure request completes even if user navigates away
        keepalive: true
      });

      if (process.env.NODE_ENV === 'development') {
        console.log('[VISITOR TRACKING] Page view tracked:', page);
      }
    } catch (error) {
      // Silently fail - don't disrupt user experience
      if (process.env.NODE_ENV === 'development') {
        console.error('[VISITOR TRACKING] Error:', error);
      }
    }
  }

  /**
   * Track custom event
   */
  async trackEvent(eventName, eventData = {}) {
    try {
      const data = {
        page: window.location.pathname,
        event: eventName,
        eventData,
        timestamp: new Date().toISOString()
      };

      await fetch(TRACKING_API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        keepalive: true
      });

      if (process.env.NODE_ENV === 'development') {
        console.log('[VISITOR TRACKING] Event tracked:', eventName, eventData);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('[VISITOR TRACKING] Error:', error);
      }
    }
  }
}

// Create singleton instance
const tracker = new VisitorTracker();

export default tracker;
